import { render, staticRenderFns } from "./notification-template-new-order.vue?vue&type=template&id=1a175d93&scoped=true"
import script from "./notification-template-new-order.vue?vue&type=script&lang=js"
export * from "./notification-template-new-order.vue?vue&type=script&lang=js"
import style0 from "./notification-template-new-order.vue?vue&type=style&index=0&id=1a175d93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a175d93",
  null
  
)

export default component.exports